var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('h3', {
    class: _vm.$style.title
  }, [_vm._v(_vm._s(_vm.category))]), _vm.resources.length ? _c('MottoIcon', {
    staticClass: "mr-4 cursor-pointer",
    class: _vm.$style.hideMobile,
    attrs: {
      "name": "Grid",
      "icon-color": "lightGray",
      "data-open-grid-view": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$emit('openGridView');
      }
    }
  }) : _vm._e(), _vm.resources.length ? _c('MottoIcon', {
    staticClass: "mr-4 cursor-pointer",
    class: _vm.$style.showMobile,
    attrs: {
      "name": "List",
      "icon-color": "lightGray",
      "data-open-grid-view-mobile": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.$emit('openGridView');
      }
    }
  }) : _vm._e()], 1), !_vm.resources.length ? _c('p', {
    class: _vm.$style.emptySentence
  }, [_vm._v(_vm._s(_vm.emptySentence))]) : _vm._e(), _vm.resources.length && !_vm.isMobile ? _c('carousel', {
    class: _vm.$style.carousel,
    attrs: {
      "per-page": _vm.perPage,
      "pagination-enabled": false,
      "navigation-enabled": true,
      "navigation-next-label": '',
      "navigation-prev-label": ''
    },
    on: {
      "page-change": _vm.changePageNumber
    }
  }, _vm._l(_vm.getResources, function (resource, index) {
    var _class;
    return _c('slide', {
      key: resource.resourceId
    }, [_vm.isResourceVisibleInCarousel(index, _vm.pageNumber, _vm.perPage) ? _c('ResourceBlock', {
      class: (_class = {}, _class[_vm.$style.resourceBlock] = true, _class[_vm.$style.minimalInMobile] = _vm.minimalInMobile, _class),
      attrs: {
        "resource": resource,
        "minimal-in-mobile": _vm.minimalInMobile
      }
    }) : _vm._e()], 1);
  }), 1) : _vm._e(), _vm.resources.length && _vm.isMobile ? _c('div', {
    class: _vm.$style.mobileCarousel
  }, [_c('div', {
    class: _vm.$style.mobileCarouselBlock
  }, _vm._l(_vm.getResources, function (resource) {
    var _class2;
    return _c('ResourceBlock', {
      key: resource.resourceId,
      class: (_class2 = {}, _class2[_vm.$style.resourceBlock] = true, _class2[_vm.$style.minimalInMobile] = _vm.minimalInMobile, _class2),
      attrs: {
        "resource": resource,
        "minimal-in-mobile": _vm.minimalInMobile
      }
    });
  }), 1)]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }